<template>
  <DropdownMenuItem
    v-bind="props"
    :class="[
      cn(
        'relative flex cursor-pointer hover:bg-neutral-50/[.12] focus:bg-neutral-50/[.12] select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        props.inset && 'pl-8',
        props.class
      ),
    ]"
  >
    <slot />
  </DropdownMenuItem>
</template>

<script setup>
import { DropdownMenuItem } from 'radix-vue';
import { cn } from '../../utils.js';

const props = defineProps({});
</script>
